"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightbulb = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var lightbulb = function lightbulb(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'lightbulb-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M7 15H13L12.6325 16.1026C12.2548 17.2357 11.1944 18 10 18C8.80562 18 7.74524 17.2357 7.36754 16.1026L7 15Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M11.9189 13.5L12.5096 11.7277C12.6276 11.3739 12.8262 11.0525 13.0899 10.7888L13.4345 10.4442C14.1167 9.76195 14.5 8.83665 14.5 7.87183C14.5 5.45734 12.5427 3.5 10.1282 3.5H9.87183C7.45734 3.5 5.5 5.45734 5.5 7.87183C5.5 8.83665 5.88327 9.76195 6.5655 10.4442L6.03517 10.9745L5.50484 11.5048C4.54131 10.5413 4 9.23448 4 7.87183C4 4.62891 6.62891 2 9.87183 2H10.1282C13.3711 2 16 4.62891 16 7.87183C16 9.23448 15.4587 10.5413 14.4952 11.5048L14.1506 11.8494C14.0516 11.9484 13.9769 12.0692 13.9327 12.202L13 15H7L6.06734 12.202C6.02305 12.0692 5.94845 11.9484 5.84942 11.8494L5.50484 11.5048L6.03517 10.9745L6.5655 10.4442L6.91009 10.7888C7.17377 11.0525 7.37244 11.3739 7.49036 11.7277L8.08114 13.5H11.9189Z',
    fill: '#4B5563'
  }));
};

exports.lightbulb = lightbulb;